import styled from '@emotion/styled'

import { TYPOGRAPHY_15 } from 'theme/theme'

const StyledInput = styled.input`
  ${TYPOGRAPHY_15}

  width: ${props => props.xl ? '300px' : '100%'};
  height: 34px;
  background: ${props => props.disabled ? '#f9f9fc' : '#fff'};
  border: ${props => props.error ? `${props.focus ? '2px' : '1px'} solid #bb002f` : `${props.focus ? '2px' : '1px'} solid #efeff2`};
  box-sizing: border-box;
  border-radius: 5px;
  color: #505259;
  text-indent: 15px;
  padding-right: 15px;

  &:-webkit-autofill {
    color: #505259;
  }
`

export default StyledInput
